import type { OpeningHoursRow } from '@/content/openingHours';

interface OpeningHoursListProps {
  rows: OpeningHoursRow[];
  variant?: 'light' | 'dark';
}

/** Two-column hours block matching the printed door sign. */
const OpeningHoursList = ({ rows, variant = 'light' }: OpeningHoursListProps) => {
  const dayClass = variant === 'dark' ? 'text-stone-400' : 'text-stone-500';
  const hoursClass =
    variant === 'dark'
      ? 'text-amber-400 font-semibold text-right tabular-nums'
      : 'font-semibold text-stone-800 text-right tabular-nums';

  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-sm items-baseline">
      {rows.map((oh, i) => (
        <div key={`${oh.day}-${oh.hours}-${i}`} className="contents">
          <span className={dayClass}>{oh.day || '\u00a0'}</span>
          <span className={hoursClass}>{oh.hours}</span>
        </div>
      ))}
    </div>
  );
};

export default OpeningHoursList;
